import PropTypes from 'prop-types'
import { productShape, nutritionalDataShape } from '@proptypes'
import { Ingredients } from '#src/products/components/list/product-card/ingredients'
import React from 'react'
import { CardWrapper } from './styles'

const ProductInfoCard = ({
  ingredients,
  ingredientsId,
  name,
  nutritionalData,
  allergens,
  children
}) => (
  <CardWrapper data-testid='product-info-card'>
    {children}
    {(ingredients || allergens.length > 0) && (
      <Ingredients
        id={ingredientsId}
        ingredients={ingredients}
        name={name}
        allergens={allergens}
        nutritionalData={nutritionalData}
      />
    )}
  </CardWrapper>
)

ProductInfoCard.propTypes = {
  ingredients: productShape.ingredients,
  ingredientsId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  nutritionalData: nutritionalDataShape,
  allergens: productShape.allergens,
  children: PropTypes.node.isRequired
}

ProductInfoCard.defaultProps = {
  allergens: [],
  nutritionalData: []
}

export default ProductInfoCard
